var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container",style:(_vm.style)},[_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.backgroundImageUrl,"alt":_vm.widget.position.name},on:{"click":function($event){$event.preventDefault();return _vm.showImage.apply(null, arguments)}}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }